import { TColorTagColor } from '../../../../../types/model';

export type TPaletteColor = TColorTagColor | string;

export enum EPaletteVariant {
    TAG_COLOR = 'TAG_COLOR',
    TAG_COLOR_KANBAN_CARD = 'TAG_COLOR_KANBAN_CARD',
    CARD_COLOR = 'CARD_COLOR'
}
